module.exports = __webpack_public_path__ + "img/Maker_Paper.eb7ff982.svg";